<template>
  <div class="wrapper">
    <!--头部-->
    <page-head title="网格管理" :btn-list="btnList" :show-back="false" @handleBtn="handleBtn"></page-head>
    <switch-tab :arr="arrtab" :selectIndex="selectIndex" class="switchTab" @changeTab="changeTab"></switch-tab>
    <!-- 网格信息 -->
    <div v-show="selectIndex==0">
      <Modal
        v-model="isShowDelete"
        title="删除网格"
        width="660px"
        @on-ok="onDelete"
        @on-cancel="onCancel"
      >
        <div>您确定要删除 {{delGridName}} 网格么？</div>
      </Modal>
      <grid-card
        :userList="userList"
        @cardClick="toDetail"
        @delPeople="delPeople"
        v-on:checkList="getCheckList"
        :checkList="checkList"
      ></grid-card>
      <div class="fenye box">
        <div class="clickAll box">
          <i
            class="iconfont icon-clickall"
            :class="[clickAll ? 'icon-duoxuan1' : 'icon-duoxuankuang1']"
            @click="checkAll"
          ></i>
          全选(当前页)
        </div>
        <Page
          :total="total"
          class="page box_f1"
          :current="pageNum"
          @on-change="handleChangePage"
          show-total
        />
        <div class="clickTotal box">
          已选
          <span style="font-size:18px;color: #fe7d43;margin-right:20px">
            {{
            checkList.length
            }}
          </span>
        </div>
      </div>

      <!-- modal 添加社工 -->
      <Modal
        v-model="addWorkerModal"
        title="添加网格"
        :mask-closable="false"
        width="660"
        class-name="vertical-center-modal"
      >
        <!--@on-change="handleClick"-->
        <div class="tr box">
          <div class="tr_title ml-10">网格地图图片</div>
          <upload-img
            :imgArr="imgArr"
            :imgNumber="imgNumber"
            :fixedNumber="fixedNumber"
            :imgHeight="148"
            :imgWidth="238"
            @saveImg="saveImg"
            @delPic="delPic"
            :isActive="isActive"
          >
            <div class="uploadbox">
              <i class="iconfont icon-shangchuan1"></i>
              <p class="fengmian">请上传图片</p>
              <!-- <p class="tips">注意图片尺寸为：2:1</p> -->
            </div>
          </upload-img>
          <!-- <Input v-model="gridName" type="text" placeholder="请输入网格名称" style="width: 90%" /> -->
        </div>
        <div class="tr box">
          <div class="tr_title">网格名称</div>
          <Input v-model="gridName" type="text" placeholder="请输入网格名称" style="width: 90%" />
        </div>
        <div class="tr box">
          <div class="tr_title">网格级别</div>
          <Select
            v-model="levelId"
            style="width:560px"
            placeholder="请选择网格级别"
            size="large"
            @on-change="getSubGridLevel"
          >
            <Option v-for="(item, index) in levelList" :value="item.id" :key="index">{{ item.name }}</Option>
          </Select>
        </div>
        <div class="tr box">
          <div class="tr_title">上级网格</div>
          <Select v-model="parentId" style="width:560px" placeholder="请选择上级网格" size="large">
            <Option
              v-for="(item, index) in subLevelList"
              :value="item.id"
              :key="index"
            >{{ item.name }}</Option>
          </Select>
        </div>
        <div class="tr box">
          <div class="tr_title">网格描述</div>
          <Input
            v-model="remark"
            type="textarea"
            :rows="4"
            placeholder="请输入网格描述"
            style="width: 90%"
          />
        </div>
        <div slot="footer">
          <Button style="margin-right:10px" @click="addWorkerModal = false">取消</Button>
          <Button type="primary" @click="addWorker">确定</Button>
        </div>
      </Modal>
    </div>
    <!-- 网络层级 -->
    <div v-show="selectIndex==1">
      <div class="content">
        <Tree :data="cascadeData"></Tree>
      </div>
    </div>
  </div>
</template>

<script>
import pageHead from "../../../components/head";
import gridCard from "../components/gridCard";
import switchTab from "../components/switchTab";
import uploadImg from "../../../components/uploadImg";
var that;
export default {
  data() {
    return {
      btnList: [
        {
          name: "添加网格",
          type: "worker",
          loading: false,
        },
      ],
      arrtab: ["网格信息", "网格层级"],
      selectIndex: 0,
      deleteCommunityid: "",
      isShowDelete: false,
      isShowSelect: false,
      pageNum: 1, // 分页1
      pageSize: 10, //  分页尺寸
      userList: [], // 用户列表
      cascadeData: [],
      rule: {
        labelParam: {},
        gridName: "",
        levelId: "",
        communityId: "",
      }, // 过滤器筛选类型
      ruleSelect: {}, //过滤筛选
      filterList: [],
      total: 2,
      clickAll: false,
      isDelAll: false,
      btnDisabled: true,
      gridList: [],
      selVal: "",
      unionId: "",
      checkList: [],
      isAddWorker: false,
      addWorkerModal: false,

      levelList: [],
      subLevelList: [],
      isActive: false,
      imgNumber: 1,
      imgArr: [],
      fixedNumber: [2, 1],
      gridName: "",
      delGridName: "",
      delId: "",
      levelId: "",
      parentId: "",
      coverPicUrl: "",
      remark: "",

      workPosition: [], // 工作单位列表
      modalSearchName: "", // 要搜索的人名
      workSearching: false, // 是否搜索已经搜索了一次，控制样式和滚动加载接口
      workPlace: "", // 工作单位
      workList: [], // 可添加为社工的人员列表
      workPageNum: 1, // 搜索人员分页
      workPageSize: 10,
      workListFinish: false, // 加载完毕
      workSelectedOne: null, // 搜索人员列表里被选中的那个
    };
  },
  created() {
    that = this;
    this.reset = this._.debounce(this._reset, 100); // filter 重置时会触发函数
  },
  watch: {
    /* 当前total发生变化时 右侧label显示跟着变化 */
    total(newVal) {
      this.$store.commit("updateLabelList", [
        {
          name: "filter_label",
          data: {
            label: "当前总网格数",
            value: newVal,
          },
        },
      ]);
    },
  },
  mounted() {
    this.getfilter(1);
    this.getWorker();
    this.getGridLevel();
    this.getGridCascade();
  },
  destroyed() {
    console.log("[sys] userSocialWorker destroyed");
    this.$store.commit("updateFilterList", []);
    this.$store.commit("updateLabelList", []);
  },
  methods: {
    saveImg(data) {
      this.imgArr.splice(0, 1, data);
      this.isActive = true;
    },
    delPic() {
      this.imgArr = [];
    },
    changeTab(index) {
      console.log(index);
      //切换发送和草稿  1为草稿 0为发送
      that.selectIndex = index;
      this.filterList = [];
      this.page = 1;
      this._reset();
      //this.getfilter(1)
    },
    getMenu(data) {
      const result = [];
      if (!data) return;
      data.forEach((element) => {
        let { levelName, gridName, children, userList } = element;
        if (children && children.length > 0) {
          children = children.map((item) => {
            return {
              title: item.levelName + " " + item.gridName,
              expand: true,
              users: item.userList && item.userList,
              children: this.getMenu(item.children),
            };
          });
          // 处理不是最后节点的用户显示
          if (userList && userList.length > 0) {
            let arr = userList.map((item) => {
             return this.getUserCard(item)
            });
            children = [...children, ...arr];
          }
          result.push({
            title: levelName + " " + gridName,
            expand: true,
            children: children,
            users: userList && userList,
          });
        } else {
          // 处理是最后节点的
          let arr = userList ? userList : [];
          result.push({
            title: levelName + " " + gridName,
            expand: true,
            children: arr.map((item) => {
              return this.getUserCard(item)
            }),
          });
        }
      });
      return result;
    },
    getUserCard(item) {
      return {
        render: (h, { root, node, data }) => {
          return h("div", {}, [
            h(
              "div",
              {
                style: {},
              },
              [
                h(
                  "div",
                  {
                    style: {
                      width: "280px",
                      height: "80px",
                      marginTop: "10px",
                      marginLeft: "10px",
                      background: "#FFFFFF",
                      border: "1px solid #DEDEDE",
                      borderRadius: "4px",
                      position: "relative",
                    },
                  },
                  [
                    h(
                      "img",
                      {
                        attrs: {
                          // name: "img",
                          src: item.headPicUrl,
                        },
                        style: {
                          position: "absolute",
                          top: "20px",
                          left: "20px",
                          width: "45px",
                          height: "45px",
                          border: "1px solid #DEDEDE",
                          borderRadius: "50%",
                        },
                      }
                      // data.user && data.user.headPicUrl
                    ),
                    h(
                      "div",
                      {
                        style: {
                          marginTop: "22px",
                          marginLeft: "90px",
                          display: "inline-block",
                          color: "#343434",
                          fontWeight: "500",
                        },
                      },
                      item.userName
                    ),
                    h(
                      "span",
                      {
                        style: {
                          marginLeft: "10px",
                          display: "inline-block",
                          color: "#9A9A9A",
                        },
                      },
                      item.phoneNO
                    ),
                    h(
                      "div",
                      {
                        style: {
                          marginLeft: "90px",
                          fontSize: "12px",
                          color: "#FF6050",
                        },
                      },
                      item.proTitle
                    ),
                  ]
                ),
              ]
            ),
          ]);
        },
      };
    },
    getGridCascade() {
      //#556b93
      let url = this.urlobj.gridCascade;
      this.$get(url).then((res) => {
        console.log("res...",res);
        let data = this.getMenu(res.rows);

        console.log("data",data);

        this.cascadeData = data;
      });
    },
    getLevelFilter() {
      let url = this.urlobj.gridLabel();
      this.$get(url, {
        labelParentType: "grid_level",
        communityIds: this.rule.communityId,
      }).then((res) => {
        console.log(res);
        let num1 = 0;

        var counts = [];

        counts = res.rows.map((item) => {
          return item.count;
        });
        counts.forEach((item) => {
          num1 += item;
        });
        var item11 = {
          name: "全部",
          id: "",
          userCount: num1,
        };
        this.gridList = res.rows.map((item) => {
          return {
            name: item.dicName,
            id: item.id,
            userCount: item.count,
          };
        });
        this.gridList.unshift(item11);
      });
    },
    getGridLevel() {
      let url = this.urlobj.gridLevel();
      this.$get(url)
        .then((res) => {
          // console.log(res);
          if (res.isSucceed) {
            /* 如果有数据 */
            if (res.rows.length) {
              this.levelList = res.rows;
            }
          }
        })
        .catch((e) => {
          console.log(e);
        });
    },
    getSubGridLevel(levelId) {
      let url = this.urlobj.gridList();
      if (levelId == 1) {
        (this.subLevelList = []), (this.parentId = "");
        return;
      }
      this.$post(url, {
        levelId: levelId - 1,
      })
        .then((res) => {
          console.log(res);
          if (res.isSucceed) {
            /* 如果有数据 */
            if (res.rows.length) {
              this.subLevelList = res.rows.map((item) => {
                return {
                  id: item.id,
                  name: item.gridName,
                };
              });
              console.log(this.subLevelList);
            }
          }
        })
        .catch((e) => {
          console.log(e);
        });
    },
    handleBtn(type) {
      this.addWorkerModal = true;
      this.initWorkModal(); // 重置modal参数
      // 没有数据时加载一次
      if (!this.workPosition.length) this.getOrgList();
    },
    // 初始化添加社工的modal
    initWorkModal() {
      this.workSearching = false;
      this.modalSearchName = "";
      this.workPlace = "";
      this.workPageNum = 1;
      this.workListFinish = false;
      this.workSelectedOne = null;
      this.workList = [];
    },
    toDetail(e) {
      // console.log(e)
      this.$router.push({
        name: "gridDetail",
        query: {
          id: e.id,
        },
      });
    },
    getCheckList(checkList) {
      this.checkList = checkList;
      console.log(this.checkList);
      console.log(this.filterList);
      let len1 = this.checkList.length;
      let len2 = this.userList.length;
      console.log(len1 == 0);
      this.btnDisabled = len1 == 0;
      if (len1 == len2) {
        this.clickAll = true;
      } else {
        this.clickAll = false;
      }
    },
    checkAll() {
      this.clickAll = !this.clickAll;
      if (this.clickAll == true) {
        this.checkList = [];
        this.userList.forEach((item) => {
          item.clickCheck = true;
          this.checkList.push(item);
        });
        this.btnDisabled = false;
      } else {
        this.userList.forEach((item) => {
          item.clickCheck = false;
        });
        this.btnDisabled = true;
        this.checkList = [];
      }
      console.log(this.checkList);
    },
    _reset() {
      this.pageNum = 1; //  初始化分页
      this.userList = []; // 用户数据置空
      this.rule = {
        realNameStatus: "",
        labelParam: {},
        gridName: "",
        levelId: "",
        communityId: this.$store.state.isJiedao
          ? ""
          : this.$store.state.streetorcommunityid,
      };
      this.getfilter(1);
      this.getWorker();
    },
    /* 获取右侧筛选分类 */
    getfilter(isFirst) {
      let filterData = [];
      var getGridLevel = this.getLevelFilter();
      // if (this.$store.state.isJiedao == 1) {
      var _url = this.urlobj.getDivision("grid");
      this.$get(_url).then((res) => {
        var num = 0;
        var ids = [];
        var counts = [];
        ids = res.rows.map((item) => {
          return item.communityId;
        });
        counts = res.rows.map((item) => {
          return item.count;
        });
        counts.forEach((item) => {
          num += item;
        });
        var item1 = {
          name: "全部",
          id: "",
          userCount: num,
        };
        var list = res.rows.map((item) => {
          return {
            name: item.communityName,
            id: item.communityId,
            userCount: item.count,
          };
        });
        list.unshift(item1);

        if (isFirst == 1 && this.$store.state.isJiedao) {
          //首次进来的
          this.rule.communityId = "";
          //this.getWorker();
        }
        // console.log(this.gridList);
        var gridIndex = 0;
        this.gridList.forEach((item, index) => {
          if (item.id == this.rule.levelId) {
            gridIndex = index;
          }
        });

        //匹配默认选中index
        var index1 = 0;
        list.forEach((item, index) => {
          if (item.id == this.rule.communityId) {
            index1 = index;
          }
        });
        // console.log(list);
        filterData.push({
          type: "gridLevel",
          name: "网格层级",
          selectedIndex: gridIndex,
          children: this.gridList,
        });
        filterData.unshift({
          type: "community",
          name: "行政区域",
          selectedIndex: index1,
          children: list,
        });
        this.filterList = [];
        for (const obj in filterData) {
          this.filterList.push(new FilterItem(filterData[obj]));
        }
        this.initFilterList(this.filterList);
      });
      // } else {
      //   for (const obj in filterData) {
      //     filterData[obj].that = this;
      //     this.filterList.push(new FilterItem(filterData[obj]));
      //   }
      //   this.initFilterList(this.filterList);
      // }
    },
    /* 获取社工列表 */
    getWorker() {
      // let url = this.urlobj.workList();
      let url = this.urlobj.gridList();
      this.$store.commit("updateSpinShow", true);
      this.$get(url, {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        communityId: "",
        ...this.rule,
      })
        .then((res) => {
          console.log(res);
          this.$store.commit("updateSpinShow", false);
          this.total = res.total;
          if (res.isSucceed) {
            /* 如果有数据 */
            if (res.rows.length) {
              /* 初始化数据 */
              var resList = res.rows.map((item, index) => {
                return {
                  id: item.id,
                  showCha: false,
                  headPicUrl: item.coverPicUrl,
                  gridName: item.gridName,
                  userCount: item.userCount,
                  levelName: item.levelName,
                  subLevelCount: item.subLevelCount,
                  clickCheck: false,
                };
              });
              this.userList = resList;
            }
          }
        })
        .catch((e) => {
          console.log(e);
        });
      // 分页加1
    },
    handleChangePage(val) {
      console.log(`第${val}页`);
      this.clickAll = false;
      this.checkList = [];
      this.btnDisabled = true;
      this.pageNum = val;
      this.getWorker();
    },
    delPeople(query) {
      // console.log(query)
      this.delGridName = query.gridName;
      this.delId = query.id;
      this.isShowDelete = true;
      // this.deleteCommunityid = query.communityId;
      /**修改删除人有待办时查询可转派人的参数 */
      this.ruleSelect = {
        communityId: [query.communityId],
        labelParam: {},
        realNameStatus: 1,
      };
    },
    onDelete() {
      // idList
      var url = this.urlobj.delGrid(this.delId);
      this.$delete(url)
        .then((res) => {
          console.log(res);
          this.isShowDelete = false;
          if (res.isSucceed) {
            this.$Message.success("删除成功");
            //删除用户
            this.pageNum = 1; //  初始化分页
            this.userList = []; // 用户数据置空
            this.checkList = [];
            this.clickAll = false;
            this.btnDisabled = true;
            this.getWorker();
            this.getfilter();
          }
        })
        .catch((e) => {
          this.isShowDelete = false;
          //this.$Message.error("删除失败");
        });
    },
    onCancel() {
      this.isShowDelete = false;
      this.isShowSelect = false;
    },
    initFilterList(list) {
      /* search 数据 */
      let search = {
        name: "search",
        data: {},
        event: function (e) {
          that[e.fn](e);
        },
      };
      list.unshift(search);
      this.$store.commit("updateFilterList", list);
    },
    /* ---------------------所有 筛选 业务处理 代码 如下--------------------*/

    /* ==================== 搜索  BEGIN==================== */
    search({ params }) {
      this.pageNum = 1; //  初始化分页
      this.userList = []; // 用户数据置空
      this.rule.gridName = params.searchValue;
      this.checkList = [];
      this.clickAll = false;
      this.btnDisabled = true;
      this.getWorker();
    },
    /* ==================== 搜索  END==================== */
    /* ==================== 认证状态  BEGIN==================== */
    authchange({ params }) {
      this.pageNum = 1; //  初始化分页
      this.userList = []; // 用户数据置空
      // this.rule.realNameStatus = params.stateCode; // 筛选条件更新
      this.checkList = [];
      this.clickAll = false;
      this.btnDisabled = true;
      this.getWorker();
    },
    /* ==================== 认证状态  END==================== */
    /* ==================== 分类  BEGIN==================== */
    /* 分类模块添加分类 */
    addSort({ params }) {
      let url = this.urlobj.addLabel();
      let data = {
        labelType: 2, // 社工 是2
        name: params.addValue,
      };
      this.$store.commit("updateSpinShow", true);
      this.$post(url, data)
        .then((res) => {
          if (res.isSucceed) {
            this.$Message.success("添加成功");
            this.getfilter();
          }
        })
        .catch((e) => console.log(e));
    },
    /* 删除模块删除分类 */
    delSort({ params }) {
      let target = this.filterList[params.filterListIndex];
      let delId = target.data.dataList[params.delIndex].id;
      let url = this.urlobj.delLabel(delId);
      this.$store.commit("updateSpinShow", true);
      this.$delete(url)
        .then((res) => {
          this.$store.commit("updateSpinShow", false);
          if (res.isSucceed) {
            this.$Message.success("删除成功");
            target.data.dataList.splice(params.delIndex, 1);
          }
        })
        .catch((e) => console.log(e));
    },
    /* 拖曳到分类 */
    sortDrop({ params }) {
      this._drop(params);
    },
    /* 勾选筛选选项 */
    sortChange({ params }) {
      this._groupChange(params);
    },
    /* ==================== 分类  END==================== */
    /* ==================== 行政区域  BEGIN==================== */
    areaChange({ params }) {
      console.log("行政区域筛选");
      this._groupChange(params);
    },
    /* ==================== 分类  END==================== */
    /* ==================== 微支部  BEGIN==================== */
    orgChange({ params }) {
      this._groupChange(params);
    },
    orgDrop({ params }) {
      // this._drop(params);
    },
    /* ==================== 微支部  END==================== */
    /* ==================== 小区  BEGIN==================== */
    comDrop({ params }) {
      // this._drop(params);
    },
    comChange({ params }) {
      this._groupChange(params);
    },
    /* ==================== 小区  END==================== */
    /* ==================== 来源  BEGIN==================== */
    oriChange({ params }) {
      this._groupChange(params);
    },
    oriDrop({ params }) {
      // this._drop(params);
    },
    /* ==================== 来源  END==================== */
    /******************* 公用方法 ************************/
    /* 勾选筛选 初始化不同的属性*/
    _groupChange(e) {
      console.log(e);
      let target = this.filterList[e.filterListIndex];
      this.pageNum = 1; //  初始化分页
      this.userList = []; // 用户数据置空

      /* 修改筛选条件 source 传type 其他的传id*/
      if (target.type == "source") {
        this.rule.labelParam[target.type] = e.selectedIndex.map((item) => {
          return target.data.dataList[item].type;
        });
      } else if (target.type == "community") {
        var val1 = target.data.dataList[e.selectedIndex].id;
        // var index = String(val1).indexOf(",");
        // var idlist = index == -1 ? [val1] : val1.split(",");
        this.rule.communityId = val1;
        this.getfilter();
      } else if (target.type == "gridLevel") {
        var val1 = target.data.dataList[e.selectedIndex].id;
        // var index = String(val1).indexOf(",");
        // var idlist = index == -1 ? [val1] : val1.split(",");
        this.rule.levelId = val1;
      } else {
        this.rule.labelParam[target.type] = e.selectedIndex.map((item) => {
          return target.data.dataList[item].id;
        });
      }
      this.getWorker();
      // if (this.rule.communityIdList.length == 1) {
      //   this.getQrcode(this.rule.communityIdList.join(","));
      // }
      this.checkList = [];
      this.btnDisabled = true;
      this.clickAll = false;
    },
    /* 拖曳放开
    2018年12月20日 暂时关闭
    */
    _drop(e) {
      let target = this.filterList[e.filterListIndex];
      let url = this.urlobj.sortToWorkerLabel();
      let data = {
        id: target.data.dataList[e.elIndex].id,
        unionId: e.dropValue,
      };
      this.$store.commit("updateSpinShow", true);
      this.$post(url, data)
        .then((res) => {
          this.$store.commit("updateSpinShow", false);
          if (res.isSucceed) {
            this.$Message.success("添加成功");
            this.filterList[e.filterListIndex].data.dataList[e.elIndex]
              .number++;
          }
        })
        .catch((e) => {
          this.$store.commit("updateSpinShow", false);
          console.log(e);
        });
    },
    /* 获取社区企业选择列表 */
    getOrgList() {
      let url = this.urlobj.belongList();
      this.$get(url, {
        isContainsCompany: 1, // 包含 企业列表,
        communityId: this.communityId,
      })
        .then((res) => {
          if (res.isSucceed && res.rows.length > 0) {
            // 社区企业的选择列表
            this.workPosition = res.rows.map((item) => {
              return {
                id: item.companyId,
                name: item.name,
              };
            });
          }
        })
        .catch((e) => console.log(e));
    },
    // 添加社工
    addWorker() {
      // 判断选中的企业
      if (!this.imgArr[0] || !this.imgArr[0].path)
        return this.$Message.warning("未上传网格地图图片");
      if (!this.gridName) return this.$Message.warning("未输入网格名称");
      if (!this.levelId) return this.$Message.warning("未选择网格级别");
      if (this.levelId != 1 && !this.parentId)
        return this.$Message.warning("未选择上级网格");
      if (!this.remark) return this.$Message.warning("未输入网格描述");

      let url = this.urlobj.addGrid();
      let data = {
        coverPicUrl: this.imgArr[0].path,
        gridName: this.gridName,
        levelId: this.levelId,
        parentId: this.parentId,
        remark: this.remark,
      };
      console.log(data);
      this.$showLoading();
      this.$post(url, data)
        .then((res) => {
          if (!res.isSucceed) return this.$Message.error(res.message);
          this.$Message.success("添加成功");
          this.imgArr = [];
          this.gridName = "";
          this.levelId = "";
          this.parentId = "";
          this.remark = "";
          this.isActive = false,
          // 关闭弹窗
          this.addWorkerModal = false;
          // 更新人员列表
          this.getWorker();
        })
        .finally(this.$hideLoading);
    },
  },
  components: {
    gridCard,
    pageHead,
    uploadImg,
    switchTab,
  },
};

/* ---------------------------筛选组件构造对象 --------------------------*/
/*
  type : 用来确定 使用哪个组件
  name ：组件显示的头部文字
  children: 子列表数据
  that: 当前页面对象
*/
function FilterItem({ type, name, children, selectedIndex }) {
  // console.log("[fn] FilterItem excuted");

  /* 如果是来源 获取图片路径 */
  // 社工页 来源类型 'sgzs','dyrh','csbd', 'sqyzs'
  this._getIconPath = function (type, obj) {
    if (type == "source") {
      switch (obj.type) {
        case "gzh":
          return require("../../../assets/images/filter/gzh.png");
        case "xfej":
          return require("../../../assets/images/filter/xfej.png");
        case "mst":
          return require("../../../assets/images/filter/mst.png");
        default:
          return "";
      }
    } else {
      return "";
    }
  };
  /* 是否可编辑 以后扩展*/
  this.editMode = function (type) {
    switch (type) {
      case "organization":
        return true;
      default:
        return false;
    }
  };
  /* 初始化 组件类型 this.name 确定组件类型 保证名称一致*/
  switch (type) {
    case "organization":
      this.name = "sort";
      break;
    case "party":
      this.name = "microorg";
      break;
    case "source":
      this.name = "origin";
      break;
    case "zone":
      this.name = "community";
      break;
    case "community":
      this.name = "singleDivision";
    case "gridLevel":
      this.name = "singleDivision";
      break;
  }
  /* 对象类型 */
  this.type = type;
  /* 初始化对象 数据 */
  this.data = {
    title: name, // 解构过来的name
    edit: this.editMode(type),
    dataList: children.map((item, index) => {
      return {
        id: item.id,
        label: item.name,
        number: item.userCount,
        iconPath: this._getIconPath(type, item),
        type: item.type || "",
      };
    }),
  };
  if (selectedIndex > -1) {
    this.data.selectedIndex = selectedIndex;
  }
  /* 初始化对象事件 写死的 由当前组件对象去处理业务逻辑，没有相关函数会报错*/
  this.event = function (e) {
    that[e.fn](e);
  };
}
</script>

<style lang="less" scoped>
/* 头部信息 开始 */
.wrapper {
  color: #666666;
  min-height: 100.1%; // 强制滚动
  // margin-right: -17px;
}
/* 头部信息 结束 */
// 分页组件
.fenye {
  // width: 100%;
  background: #fff;
  position: fixed;
  bottom: 0;
  left: 150px;
  right: 255px;
  height: 40px;
  box-shadow: 0px -5px rgba(225, 225, 225, 0.5);
  // left: 40%
}
.page {
  margin-left: 50px;
}
.clickAll {
  margin-left: 20px;
  line-height: 40px;
}
.clickTotal {
  line-height: 40px;
}
.clickBtn {
  margin-left: 80px;
  line-height: 40px;
  button {
    height: 30px;
    margin-right: 10px;
    line-height: 15px;
  }
}
/* 移动对话框 */
.add-wrapper {
  min-height: 360px;
}
.add-item {
  display: flex;
  align-items: center;
}
.add-label {
  min-width: 4em;
  white-space: nowrap;
  text-align: right;
  font-size: 18px;
  color: #666;
  margin: 15px 10px 15px 0;
}
.add-input {
  flex: 1;
}
.icon-duoxuan1 {
  color: #d22c2b;
}
.code-content {
  height: 260px;
  .code-img {
    margin: 86px auto 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 172px;
    height: 172px;
    border: 1px solid #ddd;
  }
  img {
    width: 155px;
    height: 155px;
  }
  .code-text {
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 18px;
    color: #fe9163;
    text-decoration: underline;
  }
}
.tr {
  line-height: 36px;
  margin-bottom: 15px;
  .tr_title {
    margin-left: 20px;
    margin-right: 20px;
    width: 60px;
  }
  .ml-10 {
    margin-left: 0px;
    margin-right: 0px;
    width: 100px;
  }
}

/deep/ .isActive {
  margin-top: 12px;
  margin-left: -268px;
}

/deep/ .imgbox {
  margin-top: 12px;
}

.uploadbox {
  width: 200px;
  height: 148px;
  border: 1px dashed #ddd;
  text-align: center;
  margin-top: 12px;
  .icon-shangchuan1 {
    display: block;
    font-size: 37px;
    color: #e3e3e3;
    margin-top: 32px;
  }
  .fengmian {
    font-size: 14px;
    color: #666;
    margin-top: 10px;
  }
  .tips {
    font-size: 14px;
    color: #999;
  }
}
/* 社工加入 */
.searchcard-wrapper {
  padding-top: 30px;
  height: 300px;
  overflow-y: scroll;

  display: flex;
  flex-wrap: wrap;
}
.nodata {
  margin: 0 auto;
  padding-top: 40px;
}
.search-card {
  width: 120px;
  border: 1px solid #e5e5e5;
  border-radius: 7px;
  margin-right: 20px;
  margin-bottom: 30px;
  cursor: pointer;
  position: relative;
}
.searchcard-wrapper::-webkit-scrollbar {
  width: 2px;
  height: 2px;
  background-color: #fff;
}
.searchcard-wrapper::-webkit-scrollbar-track {
  border-radius: 10px;
  background-color: #fff;
}
.searchcard-wrapper::-webkit-scrollbar-thumb {
  height: 20px;
  border-radius: 10px;
  background-color: #ccc;
}
.search-name {
  text-align: center;
  color: #4b4b4b;
  font-weight: 600;
}
.search-username {
  text-align: center;
  color: #999;
}
.select {
  border: 1px solid #ff7b44;
}
.xuanzhong-icon {
  position: absolute;
  top: -12px;
  right: -14px;
  height: 25px;
  width: 25px;
}
.avatar-wrap {
  padding: 30px 0 20px 35px;
}
.avatar {
  width: 50px;
  height: 50px;
  border-radius: 50%;
}

.switchTab {
  margin-top: 18px;
}

.content {
  background: #fff;
  margin: 0 20px;
  padding: 20px;
  border-radius: 5px;
}
</style>
